// extracted by css-extract-rspack-plugin
export default {"video":"Zce8j","thumbnail":"C5k1J"};